export default __webpack_public_path__ + "static/media/5.28703ecc.jpg";